import { FC } from "react";
import Link from "next/link";
import { useUsuarioContext } from "@/context";

export const HeaderUser: FC = () => {
  const usuario = useUsuarioContext();
  if (!usuario) {
    return null;
  }

  return (
    <>
      <span className="mx-6">
        Olá, <b>{usuario.nome}</b>
      </span>
      <Link href="/Logout" className="btn btn-light btn-sm">
        Sair
      </Link>
    </>
  );
};
